module.exports = __webpack_public_path__ + "img/function3-2.1bd974c8.svg";